import { DateTime } from 'luxon';

const LOCAL_TIMEZONE = 'local';
const MOSCOW_TIMEZONE = 'Europe/Moscow';

export const localDateToDateTime = (date: Date | null) => {
    return date
        ? DateTime.fromJSDate(date).setZone(MOSCOW_TIMEZONE, {
              keepLocalTime: true,
          })
        : null;
};

export const dateTimeToLocalDate = (date: DateTime | null) => {
    return date
        ? date.setZone(LOCAL_TIMEZONE, { keepLocalTime: true }).toJSDate()
        : null;
};

export const stringToDate = (
    inputValue: string,
    format: string
): Date | null => {
    const inputDate = DateTime.fromFormat(inputValue, format);
    if (inputDate.isValid) {
        return inputDate.toJSDate();
    }
    return null;
};

export const dateToString = (value: Date | null, format: string): string => {
    if (value) {
        const date = DateTime.fromJSDate(value);
        if (date.isValid) {
            return date.toFormat(format);
        }
        return '';
    }
    return '';
};
